export const MAX_LENGTH = 40
export const MAX_LENGTH_TAG = 20
export const MAX_OVERFLOW_LENGTH = 300
export const MAX_LINES = 1
